export default __webpack_public_path__ + "static/media/diagonalLine1.be6d2cae.png";